import { useEffect, useCallback, useRef, Fragment } from 'react';
import { l10nType } from '@type/index';

interface IKeywordProps {
    isSubmit: boolean;
    inputValue: string;
    setInputValue: (value: string) => void;
    l10nTemplate: l10nType[keyof l10nType];
}

export const Keyword = ({ isSubmit, inputValue, setInputValue, l10nTemplate }: IKeywordProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    // useEffect(() => {
    //     !isSubmit && inputRef?.current?.focus();
    // }, [isSubmit]);

    const changeCallback = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const target = e?.currentTarget as HTMLInputElement;
        const keyboardValue = target?.value;

        setInputValue(keyboardValue);
    }, []);

    return <Fragment>
        <input 
            id="suggestInput" 
            type="text" 
            value={inputValue} 
            autoComplete="off"
            data-name="suggest_input" 
            onChange={changeCallback}
            ref={inputRef}
        />
        <input type="button" value="X" title={l10nTemplate?.delete} data-name="suggest_delete" />
        <input id="suggestSubmit" type="submit" value="" title={l10nTemplate?.search} data-name="suggest_submit" />
    </Fragment>;    
}